import { ref, computed, unref } from 'vue'
import { get } from '@/api'

export function useGetIncrementedValue(
  fieldLabel,
  baseUrlRef,
  groupRef,
  prefixRef = '',
) {
  const baseUrl = unref(baseUrlRef)
  const group = computed(() => groupRef.value)
  const prefix = computed(() => prefixRef.value)
  const isIncrementing = ref(false)

  const url = computed(() => {
    let url = baseUrl
    if (group.value?.id) url += `&group=${group.value?.id}`
    if (prefix.value) url += `&prefix=${prefix.value}`
    return url
  })

  async function incrementValue() {
    let nextCode = ''
    let result
    isIncrementing.value = true
    try {
      result = await get(url.value)
      if (result.status === 200) nextCode = result.data
    } catch (error) {
      let errorMsg = `Could not increment ${fieldLabel.toLowerCase()} for group [${
        group.value?.name
      }]`
      if (prefix.value) errorMsg += ` and prefix [${prefix.value}]`
      console.error(errorMsg)
    } finally {
      isIncrementing.value = false
    }
    return nextCode
  }

  return {
    prefix,
    isIncrementing,
    incrementValue,
  }
}
